// extracted by mini-css-extract-plugin
module.exports = {"empty-conversation__text":"EmptyConversationList_empty-conversation__text__1r0FS","empty-conversation__item":"EmptyConversationList_empty-conversation__item__1YXFX"};